module.exports = __webpack_public_path__ + "static/media/app-bar-save.7d8879c4.svg";